import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-time-input',
    standalone: false,
    templateUrl: './time-input.component.html',
    styleUrl: './time-input.component.scss',
})
export class TimeInputComponent extends InputComponent {}
